import { Tag } from "antd";
import { useState } from "react";

const convertToStringArray = (input: string | string[]): string[] => {
  if (typeof input === "string") {
    try {
      return JSON.parse(input);
    } catch {
      return [];
    }
  } else if (Array.isArray(input)) {
    return input;
  } else {
    return [];
  }
};

export const TagsList = ({
  tags,
  color,
  threshold,
  style,
  tag,
}: {
  tags: string[] | string;
  color?: string;
  threshold?: number;
  style?: React.CSSProperties;
  tag?: (tag: string, index: number) => React.ReactNode | string;
}) => {
  const tagColor = color || "default";

  //sort by string length, ascending
  const tagList = convertToStringArray(tags).sort(
    (a, b) => a.length - b.length
  );

  const lengthThreshold = threshold || 2;
  const [showAllTags, setShowAllTags] = useState(false);
  const visibleTags: string[] = showAllTags
    ? tagList
    : tagList.slice(0, lengthThreshold);

  const toggleShowAllTags = () => {
    setShowAllTags(!showAllTags);
  };

  return (
    <div style={style}>
      {visibleTags.map((tagText, index) =>
        tag ? (
          tag(tagText, index)
        ) : (
          <Tag key={index} color={tagColor} className="tag">
            {tagText}
          </Tag>
        )
      )}

      {tagList.length > lengthThreshold && (
        <span
          onClick={toggleShowAllTags}
          style={{ cursor: "pointer", color: tagColor, fontSize: "10px" }}
        >
          {showAllTags ? `Hide` : `+${tagList.length - lengthThreshold} more`}
        </span>
      )}
    </div>
  );
};
